module.exports = __webpack_public_path__ + "static/media/jingteshu23.8898c445.png";